import { useOktaAuth } from '@okta/okta-react'
import { api } from 'config'
import { useEffect, useState } from 'react'

function useCheckMultiLoginUser() {
  const { oktaAuth, authState } = useOktaAuth()
  const [isMultiLoginUser, setIsMultiLoginUser] = useState(false)

  useEffect(() => {
    const checkMultiLoginUser = async () => {
      console.log('Checking if user is a authState...', authState)
      if (!authState?.accessToken?.accessToken || !authState?.idToken?.idToken)
        return

      try {
        const { payload } = oktaAuth.token.decode(authState.idToken.idToken)
        if (!payload.memberMlsId) return

        console.log(
          'Checking if user is a multi-login user with memberMlsId:',
          payload.memberMlsId,
        )

        const response = await fetch(
          api.isMultiLoginUser(payload.memberMlsId as string),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${authState.accessToken.accessToken}`,
            },
          },
        )

        if (response.ok) {
          const data = await response.json()
          setIsMultiLoginUser(data.isMultiLoginUser === true)
        }
      } catch (error) {
        console.error('Error checking multi-login user status:', error)
      }
    }

    checkMultiLoginUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, oktaAuth])

  return isMultiLoginUser
}

export default useCheckMultiLoginUser
